module.exports = __webpack_public_path__ + "static/lizardfolk-1-1e2e1a321c4a2f262f40e22483c09566.png";